import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "product-price-details" }
const _hoisted_2 = { class: "product-price-details__prices" }
const _hoisted_3 = ["colspan"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "d-none d-print-inline" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "product-price-details__downloads"
}
const _hoisted_8 = ["href"]

import TelevisionPackageInterface from '@/interfaces/TelevisionPackageInterface';
import {
  computed,
} from 'vue';
import { formatNumber } from '@/helpers';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { faDownload } from '@fortawesome/pro-regular-svg-icons';
import Product from '@/classes/Product';


export default /*#__PURE__*/_defineComponent({
  __name: 'PriceDetailsTableInternet',
  props: {
    product: {},
    withAddons: { type: Boolean }
  },
  setup(__props: any) {

library.add(faInfoCircle, faDownload);

const props = __props;

const getAddonMonthlyBasePrice = (item: TelevisionPackageInterface) => item?.price?.recurring?.find((recurringPrice) => recurringPrice?.type === 'base_price')?.value || 0;
const getAddonMonthlyBasePriceFormatted = (item: TelevisionPackageInterface) => formatNumber(getAddonMonthlyBasePrice(item), 2);
const getAddonOneTimeBasePrice = (item: TelevisionPackageInterface) => item?.price?.oneTime?.find((recurringPrice) => recurringPrice?.type === 'base_price')?.value || 0;
const getAddonOneTimeBasePriceFormatted = (item: TelevisionPackageInterface) => formatNumber(getAddonOneTimeBasePrice(item), 2);

const addonsWithPrice = computed(() => props.product.addons.filter((addon) => (getAddonMonthlyBasePrice(addon.item) + getAddonOneTimeBasePrice(addon.item)) > 0));

const getAddonLabel = (addon) => {
  switch (addon.category) {
    case 'router':
      return `Router Upgrade: ${addon.item.name}`;
    case 'television-package':
      return `TV-${addon.item.name}`;
    case 'television-option':
      return `TV-Zusatzoption: ${addon.item.name}`;
    case 'television-addon':
      return `TV-Sprachpaket: ${addon.item.name}`;
    default:
      return addon.item.name;
  }
};

const rowsPrices = computed(() => {
  const rows: Record<any, unknown>[] = [];

  const savings = props.product.getPriceSavings();

  savings.forEach((saving, inx) => {
    let savingPrice = props.product.getRecurringPriceValue('base_price') - saving.value;
    if (savingPrice < 0) savingPrice = 0;

    rows.push({
      label: inx === 0 ? 'Preis pro Monat' : `Ab dem ${saving.fromMonth}. Monat`,
      value: `${formatNumber(savingPrice, 2)}&thinsp;€&thinsp;/&thinsp;Monat`,
    });
  });

  if (savings.length) {
    rows.push({
      label: `Ab dem ${savings[savings.length - 1].toMonth + 1}. Monat`,
      value: `${props.product.getRecurringPriceValueFormatted('base_price')}&thinsp;€&thinsp;/&thinsp;Monat`,
    });
  } else {
    rows.push({
      label: 'Preis pro Monat',
      value: `${props.product.getRecurringPriceValueFormatted('base_price')}&thinsp;€&thinsp;/&thinsp;Monat`,
    });
  }

  if (props.withAddons && addonsWithPrice.value.length) {
    addonsWithPrice.value.forEach((addon) => {
      if (addon.category !== 'service') {
        rows.push({
          label: getAddonLabel(addon),
          value: `${getAddonMonthlyBasePriceFormatted(addon.item)}&thinsp;€/Monat`,
        });
      }
    });
  }

  if (props.product.getOneTimePriceValueFormatted('setup_fee')) {
    rows.push({
      label: 'Bereitstellungsgebühr',
      value: `${props.product.getOneTimePriceValueFormatted('setup_fee')}&thinsp;€`,
    });
  } else {
    rows.push({
      label: 'Keine Bereitstellungsgebühr',
    });
  }

  if (props.withAddons && addonsWithPrice.value.length) {
    addonsWithPrice.value.forEach((addon) => {
      if (addon.category === 'service') {
        rows.push({
          label: getAddonLabel(addon),
          value: `${getAddonOneTimeBasePriceFormatted(addon.item)}&thinsp;€`,
        });
      }
    });
  }

  rows.push({
    label: 'Vertragslaufzeit',
    value: `${props.product.contractTermLabel}`,
  });

  rows.push({
    label: 'Vertragsverlängerung',
    value: 'Um jeweils 1 Monat',
  });

  return rows;
});

const rowsDownloads = computed(() => {
  const rows: Record<'label' | 'href' | 'key', string>[] = [];

  const infoDocument = props.product.getDocumentByKey('info');
  if (infoDocument) {
    rows.push({
      key: infoDocument.key,
      label: infoDocument.name || '',
      href: infoDocument.url || '#',
    });
  }

  const agbDocument = props.product.getDocumentByKey('agb');
  if (agbDocument) {
    rows.push({
      key: agbDocument.key,
      label: agbDocument.name || '',
      href: agbDocument.url || '#',
    });
  }

  const avbDocument = props.product.getDocumentByKey('avb');
  if (avbDocument) {
    rows.push({
      key: avbDocument.key,
      label: avbDocument.name || '',
      href: avbDocument.url || '#',
    });
  }

  return rows;
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_IoTooltip = _resolveComponent("IoTooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowsPrices.value, (row) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: row.label
        }, [
          _createElementVNode("td", {
            class: "fs-regular",
            colspan: row.value ? 1 : 2
          }, [
            _createElementVNode("span", {
              innerHTML: row.label
            }, null, 8, _hoisted_4),
            _createElementVNode("sup", _hoisted_5, _toDisplayString(row.sub), 1),
            _createTextVNode("  "),
            (row.info)
              ? (_openBlock(), _createBlock(_component_IoTooltip, {
                  key: 0,
                  class: "color-primary d-print-none"
                }, {
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.info), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_FontAwesomeIcon, { icon: _unref(faInfoCircle) }, null, 8, ["icon"])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ], 8, _hoisted_3),
          (row.value)
            ? (_openBlock(), _createElementBlock("td", {
                key: 0,
                class: "fs-regular",
                innerHTML: row.value
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    (rowsDownloads.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowsDownloads.value, (row) => {
            return (_openBlock(), _createElementBlock("a", {
              key: `download--${row.key}`,
              href: row.href,
              target: "_blank"
            }, [
              _createElementVNode("span", null, [
                _createVNode(_component_FontAwesomeIcon, { icon: _unref(faDownload) }, null, 8, ["icon"])
              ]),
              _createElementVNode("span", null, _toDisplayString(row.label), 1)
            ], 8, _hoisted_8))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})